import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { isValidImageFile, formatFileSize } from '../utils/imageUtils';
import config from '../config';

const UploadZone = ({ onFilesSelected, disabled }) => {
  const [dragActive, setDragActive] = useState(false);

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (disabled) return;

    // Filter valid images
    const validFiles = acceptedFiles.filter(isValidImageFile);
    
    if (rejectedFiles.length > 0) {
      alert(`Some files were rejected. Please only upload images (JPEG, PNG, GIF, WebP, HEIC)`);
    }

    if (validFiles.length > 0) {
      onFilesSelected(validFiles);
    }
  }, [onFilesSelected, disabled]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp', '.heic']
    },
    maxSize: config.maxFileSize,
    disabled,
    multiple: true,
  });

  return (
    <div
      {...getRootProps()}
      className={`
        relative w-full max-w-2xl mx-auto
        aspect-square md:aspect-video
        border-4 border-dashed rounded-2xl
        transition-all duration-300 cursor-pointer
        flex flex-col items-center justify-center
        p-8 text-center
        ${disabled ? 'opacity-50 cursor-not-allowed bg-gray-100' : 'hover:border-primary-500 hover:bg-primary-50'}
        ${isDragActive || dragActive ? 'border-primary-500 bg-primary-50 scale-105' : 'border-gray-300 bg-gray-50'}
      `}
    >
      <input {...getInputProps()} />
      
      <div className="space-y-2 md:space-y-4">
        <div className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl">
          📸
        </div>
        
        <div>
          <p className="text-sm sm:text-base md:text-xl lg:text-2xl font-semibold text-gray-700 mb-1 md:mb-2">
            {isDragActive || dragActive ? 'Drop your photos here' : 'Drop your photos here'}
          </p>
          <p className="text-xs sm:text-sm md:text-base text-gray-500">
            or click to browse
          </p>
        </div>

        <div className="text-xs md:text-sm text-gray-400 space-y-0.5 md:space-y-1">
          <p className="text-[10px] sm:text-xs md:text-sm">Supports: JPEG, PNG, GIF, WebP, HEIC</p>
          <p className="text-[10px] sm:text-xs md:text-sm">Max file size: {formatFileSize(config.maxFileSize)}</p>
          <p className="text-[10px] sm:text-xs md:text-sm">You can upload up to {config.maxFiles} photos</p>
        </div>
      </div>
    </div>
  );
};

export default UploadZone;

